export const downloadJSONAsJSON = (jsonData: any, fileName: string) => {
    const dataStr = JSON.stringify(jsonData);
    const element = document.createElement("a");
    // Added the BOM to the beginning of the data string and type encoding to utf-8 to handle Thai
    const file = new Blob([dataStr], {
        type: "text/json; charset=utf-8;",
    });
    element.href = URL.createObjectURL(file);
    element.download = `${fileName}.json`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
};
